import { ListHeading } from "@/components/shared/list-header";
import { Button, Card, CardContent, View } from "@/components/ui";
import { SquaresFour } from "@/components/shared/icons";
import { ServiceIcon } from "@/components/shared/service-icon";
import { popularServiceItems } from "@/containers/homepage/lib";
import { useState } from "react";
import { AllServicesModal } from "../homepage/all-services";
import { getPlatform } from "@/lib/utils";
import { useRoute } from "@/components/shared/router";

export function MakeABooking() {
  const [modalOpen, handleOpenChange] = useState(false);
  const serviceItems = popularServiceItems();
  const { push } = useRoute();
  const platform = getPlatform();

  const viewAll = () => {
    if (platform === "web") {
      handleOpenChange(true);
      return;
    }
    push({ pageKey: "allServices" });
  };

  return (
    <Card shadow="sm">
      <CardContent className="flex flex-col gap-4 p-4">
        <ListHeading
          icon={SquaresFour}
          title="Make a Booking"
          action={
            <View className="block md:hidden">
              <Button
                variant="tertiary"
                color="CTA2"
                onClick={viewAll}
                children="View All"
              />
            </View>
          }
        />

        <View className="native:flex native:flex-row grid grid-flow-col grid-cols-4 gap-4">
          {serviceItems.map((service) => (
            <ServiceIcon key={service.name} {...service} />
          ))}
        </View>

        <AllServicesModal
          modalOpen={modalOpen}
          handleOpenChange={handleOpenChange}
        />
      </CardContent>
    </Card>
  );
}
